'use strict';

angular.module('imagetrend.components')
    .directive('multipleSelect', [
        '$rootScope',
        '$filter',
        '$http',
        function ($rootScope, $filter, $http) {
            return {
                restrict: 'EA',
                scope : {
                    suggestionsArr: '=?',
                    cachedArr: '=?',
                    ngModel: "=?",
                    apiUrl : '@',
                    beforeSelectItem: '=?',
                    clear: "&?",
                    afterSelectItem : '=?',
                    beforeRemoveItem : '=?',
                    afterRemoveItem : '=?',
                    onChangeFunction: '&?',
                    question: '=?'
                },
                templateUrl: 'templates/multiple-select/multiple-select.html',
                link: function (scope, element, attr, ngModel) {

                    scope.objectProperty = attr.objectProperty;
                    scope.selectedItemIndex = 0;
                    scope.name = attr.name;
                    scope.isRequired = attr.isRequired;
                    scope.errMsgRequired = attr.errMsgRequired;
                    scope.isDisabled = attr.disable;
                    scope.isHover = false;
                    scope.isFocused = false;
                    if (!scope.isDisabled) { scope.isDisabled = false; } else { if (scope.isDisabled == 'true' || scope.isDisabled == true) { scope.isDisabled = true; } else { scope.isDisabled = false; } }
                    if (!scope.isRequired) { scope.isRequired = false; } else { if (scope.isRequired == 'true' || scope.isRequired == true) { scope.isRequired = true; } else { scope.isRequired = false; } }

                    var getSuggestionsList = function () {
                        var url = scope.apiUrl;
                        $http({
                            method: 'GET',
                            url: url
                        }).then(function (response) {
                            scope.suggestionsArr = response.data;
                        }, function (response) {
                            console.log("*****Angular-multiple-select **** ----- Unable to fetch list");
                        });
                    };

                    if (scope.suggestionsArr == null || scope.suggestionsArr == "") {
                        if(scope.apiUrl != null && scope.apiUrl != "")
                            getSuggestionsList();
                        else{
                            console.log("*****Angular-multiple-select **** ----- Please provide suggestion array list or url");
                        }
                    }

                    scope.clear();

                    scope.onFocus = function () {
                        scope.isFocused=true
                    };

                    scope.onMouseEnter = function () {
                        scope.isHover = true
                    };

                    scope.onMouseLeave = function () {
                        scope.isHover = false;
                    };

                    scope.onBlur = function () {
                        scope.isFocused=false;
                    };

                    scope.onChange = function () {
                        scope.selectedItemIndex = 0;
                    };

                    scope.keyParser = function ($event) {
                        var keys = {
                            38: 'up',
                            40: 'down',
                            8 : 'backspace',
                            13: 'enter',
                            9 : 'tab',
                            27: 'esc'
                        };
                        var key = keys[$event.keyCode];
                        if(key == 'backspace' && scope.inputValue == ""){
                            if (scope.ngModel.length != 0) {
                                scope.removeAddedValues(scope.ngModel[scope.ngModel.length-1]);
                                //scope.ngModel.pop();
                            }
                        }
                        else if(key == 'down'){
                            var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                            filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                            if(scope.selectedItemIndex < filteredSuggestionArr.length -1)
                                scope.selectedItemIndex++;
                        }
                        else if(key == 'up' && scope.selectedItemIndex > 0){
                            scope.selectedItemIndex--;
                        }
                        else if(key == 'esc'){
                            scope.isHover = false;
                            scope.isFocused=false;
                        }
                        else if(key == 'enter'){
                            var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                            filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                            if(scope.selectedItemIndex < filteredSuggestionArr.length)
                                scope.onSuggestedItemsClick(filteredSuggestionArr[scope.selectedItemIndex]);
                        }
                    };

                    scope.onSuggestedItemsClick = function (selectedValue) {
                        if(scope.beforeSelectItem && typeof(scope.beforeSelectItem) == 'function')
                            scope.beforeSelectItem(selectedValue);
                        if (!angular.isArray(scope.ngModel)) {
                            scope.ngModel = [];
                        }
                        scope.ngModel.push(selectedValue);

                        if(scope.afterSelectItem && typeof(scope.afterSelectItem) == 'function')
                            scope.afterSelectItem(selectedValue);

                        if(scope.onChangeFunction && typeof(scope.onChangeFunction) == 'function')
                            scope.onChangeFunction(scope.ngModel);

                        scope.inputValue = "";
                    };

                    var isDuplicate = function (arr, item) {
                        var duplicate = false;
                        if(arr == null || arr == "")
                            return duplicate;

                        for(var i=0;i<arr.length;i++){
                            duplicate = angular.equals(arr[i], item);
                            if(duplicate)
                                break;
                        }
                        return duplicate;
                    };

                    scope.alreadyAddedValues = function (item) {
                        var isAdded = true;
                        isAdded = !isDuplicate(scope.ngModel, item);
                        return isAdded;
                    };

                    scope.removeAddedValues = function (item) {
                        if(scope.ngModel != null && scope.ngModel != "") {
                            var itemIndex = scope.ngModel.indexOf(item);
                            if (itemIndex != -1) {
                                if(scope.beforeRemoveItem && typeof(scope.beforeRemoveItem) == 'function')
                                    scope.beforeRemoveItem(item);

                                scope.ngModel.splice(itemIndex, 1);

                                if(scope.afterRemoveItem && typeof(scope.afterRemoveItem) == 'function')
                                    scope.afterRemoveItem(item);

                                if(scope.onChangeFunction && typeof(scope.onChangeFunction) == 'function')
                                    scope.onChangeFunction(scope.ngModel);
                            }
                        }
                    };

                    scope.mouseEnterOnItem = function (index) {
                        scope.selectedItemIndex = index;
                    };
                }
            };
        }
    ])
;